(() => {
  const headerSection = document.querySelector('.section-header');
  const header = document.querySelector('header');

  const placeholder = document.createElement('div');
  placeholder.classList.add('header-placeholder');
  headerSection.before(placeholder);

  const updateHeaderProperty = () => {
    // for search bar
    document.documentElement.style.setProperty('--header-height', header.parentElement.offsetHeight + 'px');
  }

  window.addEventListener('resize', () => {
    updateHeaderProperty();
  });

  updateHeaderProperty();
})();